import React from 'react'
import { Outlet } from 'react-router-dom'
import Bannerlogo from './Bannerlogo'
import Mobilebar from './Mobilebar'
import Navbar from './Navbar'
import Popup from '../../component/Popup'

const Layout = () => {

  return (
    <div className="container mx-auto">
        {/* <Navbar/> */}
        <Bannerlogo/>
        {/* <Popup/> */}
        <section className="bg-[#ffffff] min-h-screen pb-12 md:pb-0">
            <Outlet/>
        </section>
       <Mobilebar/>
    </div>
  )
}

export default Layout